import { StyledForm } from "./styled.js"

const FormDefault = ({title, children, callback})=>{

    return(
        <StyledForm onSubmit={callback}>
            <h1>{title}</h1>
            {children}
        </StyledForm>
    )
}

export default FormDefault